import {USER_KEY} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(USER_KEY)
